import { InjectionToken } from '@angular/core';

export interface AppEnvironment {
  apiUrl: string;
  projectsApi: string;
  projectroles: string;
  projectGroupRoles: string;
  groupRolePermissions: string;
  projectGroupRolePermissions: string;
  modelsApi: string;
  revisionsApi: string;
  apiUrlRevisions: string;
  account: string;
  identityApi: string;
  identityAccount: string;
  identityAdmin: string;
  userProfile: string;
  userPermissions: string;
  permissions: string;
  genericDocuments: string;
  documents: string;
  valueConfPage: string;
  valueConfAttribute: string;
  attributeValue: string;
  statusColor: string;
  databaseMigrations: string;
  groupRoles: string;
  platformGroupRoles: string;
  tenants: string;
  tenantProjects: string;
  tenantUsers: string;
  tenantProjectGroupRoles: string;
  tenantGroupRolePermissions: string;
  tenantProjectRoles: string;
  tenantProjectGroupRolePermissions: string;
  tenantplatformGroupRoles: string;
  tenantpermissions: string;
  tenantgrouproles: string;
  tenantapplicationtokens: string;
  tenantaudit: string;
  tenantfiles: string;
  projecturl: string;
  localLegacySquirrelCommonApi: string;
  localLegacySquirrelV3: string;
  devLegacySquirrelCommonApi: string;
  devLegacySquirrelV3: string;
  squirreltest1LegacySquirrelCommonApi: string;
  squirreltest1LegacySquirrelV3: string;
  sq3devLegacySquirrelCommonApi: string;
  sq3devLegacySquirrelV3: string;
  squirreltest2LegacySquirrelV3?: string;
  [key: string]: unknown;
}

export const APP_ENVIRONMENT = new InjectionToken<AppEnvironment>('APP_ENVIRONMENT');
